/* eslint-disable react/jsx-fragments */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Typography,
  Box, Button,
  FormControlLabel,
  TextField,
  Container,
  Checkbox,
  // Divider,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import es from 'react-phone-input-2/lang/es.json'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Link as RouterLink, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import PhoneInput from 'react-phone-input-2'
import jwtdecode from 'jwt-decode';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { Carousel } from 'react-responsive-carousel';
import LanguageSwitcher from './LanguageSwitcher';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ErrorFocus from '../../components/ErrorFocus/ErrorFocus';
import GoogleAuthButton from '../../components/GoogleAuthButton/Index';
import SnackBar from '../../components/snackbar/snackbar';
import loginServices from '../../services/loginServices';
import apiClient from '../../services/apiClient';
import BackgroundImg from '../../assets/logo/images/bg.jpg';
import BackgroundImges1 from '../../assets/logo/images/backgroundImage1.png';
import BackgroundImges2 from '../../assets/logo/images/backgroundImage2.png';
import BackgroundImges3 from '../../assets/logo/images/backgroundImage3.png';
import BackgroundImges4 from '../../assets/logo/images/backgroundImage4.png';
import BackgroundImges5 from '../../assets/logo/images/backgroundImage5.png';
import LoginImage from '../../assets/logo/LoginImg.png'
import Register from "./Signup"
import './style.css'
import Logo from '../../assets/logo/logo.png';
import PhoneNumber from '../../components/PhoneNumber/Index';

export const GetStarted = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation('translation');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = React.useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [searchParams] = useSearchParams();
  const [initialcomponent, setInitialComponent] = useState(true);
  const [userDetails, setUserDetails] = useState('');
  const [carouselHeight, setCarouselHeight] = useState('100%');
  const carouselRef = useRef(null);

  const [formValues] = React.useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    agreeToTerms: false
    // confirmPassword: '',
  });

  const [passwordError, setPasswordError] = useState('');
  console.log(passwordError, "passwordError");


  const levenshtein = (a, b) => {
    const matrix = Array.from({ length: a.length + 1 }, (_, i) =>
      Array.from({ length: b.length + 1 }, (_, j) => {
        if (i === 0) return j;
        if (j === 0) return i;
        return 0;
      })
    );

    a.split('').forEach((charA, i) => {
      b.split('').forEach((charB, j) => {
        const row = i + 1;
        const col = j + 1;
        matrix[row][col] = charA === charB
          ? matrix[row - 1][col - 1]
          : 1 + Math.min(
            matrix[row - 1][col],
            matrix[row][col - 1],
            matrix[row - 1][col - 1]
          );
      });
    });

    return matrix[a.length][b.length];
  };


  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}[\]:;"'<>,.?/-]).{8,}$/;
  const validatePassword = (password) => {
    if (!passwordRegex.test(password)) {
      return (
        <p>{"Password should contain a minimum of 8 characters."}</p>
      );

    }
    return '';
  };

  useEffect(() => {
    validatePassword(formValues.password)
    setPasswordError('')
  }, [t]);

  const websiteUserLogin = async (values) => {
    console.log(values);
    setLoading(true);

    const resetData = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email.toLowerCase(),
      phone: values.phone,
      password: values.password,
      // confirmPassword: values.password,
    };

    try {
      const response = await loginServices.postUserLogin(resetData);

      if (response.ok) {
        const redirectParam = searchParams.get('redirect');
        if (redirectParam) {
          localStorage.setItem('redirectAfterLogin', redirectParam);
        }
        setUserDetails(response.data.userId);

        await loginServices.sendSignupOtp({
          email: values.email.toLowerCase(),
          firstName: values.firstName,
        });

        navigate('/verify-otp', {
          state: {
            email: values.email.toLowerCase(),
            firstName: values.firstName,
            redirect: redirectParam || '',
          },
        });
      }
      else {
        console.log('response...', response.data.message)
        setSnackbarTitle(response.data.message);
        setSnackbar(true);
      }

      setLoading(false);

    } catch (error) {
      console.log(error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Something went wrong. Please try again.';
      setSnackbarTitle(errorMessage);
      setSnackbar(true);
      setLoading(false);
    }
  };

  // Google sign-up/sign-in — same POST /authenticate call and 'googleId' backend
  // branch used on /login, so an existing Google account logs straight in and a
  // new one is created seamlessly (Google already verifies the email, so unlike
  // password signup this skips the email-verification redirect).
  const handleGoogleAuthSuccess = async (credentialResponse) => {
    if (!credentialResponse?.credential) return;
    setLoading(true);
    try {
      const response = await loginServices.userLogin({
        googleId: credentialResponse.credential,
        schema: localStorage.getItem('tenant_kss') || 'public',
      });

      if (!response.ok) {
        setSnackbarTitle(response.data?.message || 'Google sign-in failed. Please try again.');
        setSnackbar(true);
        setLoading(false);
        return;
      }

      apiClient.setHeader('Authorization', `BEARER ${response.data.token}`);
      Cookies.set('token', response.data.token);
      Cookies.set('refreshToken', response.data.refreshToken);
      Cookies.set('isLogIn', true);
      const decoded = jwtdecode(response.data.token);
      Cookies.set('tokenExpireTime', decoded.exp);

      const redirectParam = searchParams.get('redirect');
      if (redirectParam) {
        localStorage.setItem('redirectAfterLogin', redirectParam);
      }
      navigate('/auth/subscribe', { replace: true });
    } catch (error) {
      console.log(error);
      setSnackbarTitle('Something went wrong. Please try again.');
      setSnackbar(true);
    }
    setLoading(false);
  };

  const handleGoogleAuthError = () => {
    setSnackbarTitle('Google sign-in failed. Please try again.');
    setSnackbar(true);
  };

  const handleClickShowPassword = () => {
    setVisible(!visible);
  };

  // const images = [BackgroundImges1, BackgroundImges2, BackgroundImges3, BackgroundImges4, BackgroundImges5];
  const images = [LoginImage];

  // eslint-disable-next-line no-unused-vars
  const [index, setIndex] = useState(0);
  const [details, setDetails] = useState("");

  const [validationSnackbar, setValidationSnackbar] = useState(false);
  const [validationMessages, setValidationMessages] = useState([]);

  const handleValidationErrors = (errors) => {
    const errorMessages = [];

    // Collect all validation error messages
    Object.keys(errors).forEach(field => {
      if (errors[field]) {
        let fieldName = field;

        // Format field names for better readability
        switch (field) {
          case 'firstName':
            fieldName = 'First Name';
            break;
          case 'lastName':
            fieldName = 'Last Name';
            break;
          case 'email':
            fieldName = 'Email';
            break;
          case 'password':
            fieldName = 'Password';
            break;
          case 'phone':
            fieldName = 'Phone Number';
            break;
          case 'agreeToTerms':
            fieldName = 'Terms & Conditions';
            break;
          default:
            fieldName = field.charAt(0).toUpperCase() + field.slice(1);
        }

        errorMessages.push(`${fieldName}: ${t(errors[field])}`);
      }
    });

    if (errorMessages.length > 0) {
      setValidationMessages(errorMessages);
      setValidationSnackbar(true);
    }
  };

  const handleCloseValidationSnackbar = () => {
    setValidationSnackbar(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, 2000);
    return () => clearInterval(interval);
  }, []);


  const CreateButton = (data) => {
    console.log(data, "data");
    setInitialComponent(false)
    setDetails(data)
  }


  useEffect(() => {
    const updateCarouselHeight = () => {
      const signupElement = document.getElementById('SignupIs');
      if (signupElement) {
        const signupHeight = signupElement.offsetHeight;
        setCarouselHeight(`${signupHeight}px`);
      }
    };


    updateCarouselHeight();

    window.addEventListener('resize', updateCarouselHeight);

    const observer = new MutationObserver(updateCarouselHeight);
    const signupElement = document.getElementById('SignupIs');
    if (signupElement) {
      observer.observe(signupElement, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    return () => {
      window.removeEventListener('resize', updateCarouselHeight);
      observer.disconnect();
    };
  }, []);




  return (

    <>
      {initialcomponent === true ?
        <Box className={classes.mainContainer}>
          <Container maxWidth="lg" style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Grid container spacing={2} id="loginPanelIs" alignItems="stretch">
              <Grid item xs={12} md={4.5} id="SignupIs">
                <Formik
                  enableReinitialize
                  initialValues={formValues}
                  validationSchema={Yup.object().shape({
                    firstName: Yup.string()
                      .trim()
                      .matches(/^[A-Za-z ]+$/, 'Only alphabets are allowed for this field')
                      .required('First name is required'),

                    lastName: Yup.string()
                      .trim()
                      .matches(/^[A-Za-z ]+$/, 'Only alphabets are allowed for this field')
                      .nullable(),
                    password: Yup.string()
                      .trim()
                      .min(4, 'Password must be at least 4 characters long')
                      .required('Password is required'),
                    // email: Yup.string()
                    //   .required('email_required')
                    //   .email('Email must be valid email'),
                    email: Yup.string()
                      .required('email_required')
                      .email('Email must be valid email')
                      .test(
                        'blocked-domain',
                        'Email domain is not allowed',
                        (value) => {
                          if (!value) return true;

                          const blockedDomains = ['web-library.net'];
                          const domain = value.split('@')[1]?.toLowerCase();

                          return !blockedDomains.includes(domain);
                        }
                      ),
                    agreeToTerms: Yup.boolean().oneOf([true], 'Please accept the Terms and Conditions to create your keySkillset account.'),
                    phone: Yup.string().trim().nullable(),
                  })}
                  onSubmit={(values) => {
                    websiteUserLogin(values);
                  }}
                >
                  {({ errors, handleBlur, handleChange, touched, values }) => (
                    <Form>


                      <Grid container spacing={1}>
                        <Grid item xs="12">
                          <img src={Logo} alt="logo" width="145" style={{ margin: 'auto', height: '48px', width: '102px' }} />
                          <Typography color="#000000" className={classes.login} variant="h6" style={{ marginTop: "10px", marginBottom: "0px", textAlign: 'center' }}>
                            {/* {t('signUp')} */}
                            Create Your Account
                          </Typography>
                        </Grid>
                        <Grid item xs="12" style={{ marginTop: "-10px", textAlign: 'center' }}>
                          <Typography style={{
                            fontSize: "12px",
                            color: 'rgb(171, 171, 171)', fontWeight: 500
                          }} >
                            {/* {t('signUpHeader')} */}
                            A great pathway to Learning begins here!
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" style={{ fontSize: "12px", color: '#333', fontWeight: 500, marginLeft: '15px', paddingTop: "10px" }} color="textSecondary">
                            First Name <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            name="firstName"
                            placeholder={t('firstName')}
                            variant="outlined"
                            color="success"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            type="text"
                            value={values.firstName}
                            // error={Boolean(touched.firstName && errors.firstName)}
                            // helperText={touched.firstName && errors.firstName ? t(errors.firstName) : ''}
                            inputProps={{ maxLength: 180 }}
                            sx={{
                              marginTop: "5px",
                              '& input::placeholder': {
                                fontSize: '0.85rem',
                              },
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '30px',
                                '& fieldset': {
                                  borderColor: 'transparent',

                                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                                },
                                '& input': {
                                  padding: '8px 14px', // Adjust this to reduce height
                                  height: 'auto', // Optional, for better control
                                },
                                '& .MuiFormHelperText-root': {
                                  marginLeft: '14px',
                                  marginTop: '4px',
                                  marginBottom: '4px',
                                  fontSize: '0.75rem',
                                  lineHeight: '1.1',
                                },
                              },
                            }}

                          />
                          {/* <ErrorFocus /> */}
                          {touched.firstName && errors.firstName && (
                            <Typography style={{ marginLeft: 12, lineHeight: '1.2', marginTop: '5px' }} color="error" variant="body2">
                              {errors.firstName}
                            </Typography>
                          )}
                        </Grid>


                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle1" style={{ fontSize: "12px", color: '#333', fontWeight: 500, marginLeft: '15px', paddingTop: '10px' }} color="textSecondary">
                            Last Name
                          </Typography>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="lastName"
                            placeholder={t('lastName')}
                            color="success"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            type="text"
                            value={values.lastName}
                            variant="outlined"
                            // error={Boolean(touched.lastName && errors.lastName)}
                            // helperText={touched.lastName && errors.lastName ? t(errors.lastName) : ''}

                            inputProps={{ maxLength: 180 }}
                            sx={{
                              marginTop: "5px",
                              borderRadius: '30px',
                              '& input::placeholder': {
                                fontSize: '0.85rem',
                              },
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '30px',
                                '& fieldset': {
                                  borderColor: 'transparent',
                                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                                },
                                '& input': {
                                  padding: '8px 14px', // Adjust this to reduce height
                                  height: 'auto', // Optional, for better control
                                },
                              },
                            }}
                          />
                          {/* <ErrorFocus /> */}
                          {touched.lastName && errors.lastName && (
                            <Typography style={{ marginLeft: 12, lineHeight: '1.2', marginTop: '5px' }} color="error" variant="body2">
                              {errors.lastName}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Typography variant="subtitle1" style={{ fontSize: "12px", color: '#333', fontWeight: 500, marginLeft: '15px', paddingTop: "5px" }} color="textSecondary">
                            Email Address <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="email"
                            color="success"
                            placeholder={t('email')}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            // disabled={props.mode === 'edit'}
                            type="text"
                            value={values.email}
                            variant="outlined"
                            error={Boolean(touched.email && errors.email)}
                            helperText={touched.email && errors.email ? t(errors.email) : ''}
                            sx={{
                              marginTop: "5px",
                              borderRadius: '30px',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '30px',
                                '& fieldset': {
                                  borderColor: 'transparent',
                                  backgroundColor: 'none',
                                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                                },
                                '& input::placeholder': {
                                  fontSize: '0.85rem',
                                },
                                '& input': {
                                  padding: '8px 14px', // Adjust this to reduce height
                                  height: 'auto', // Optional, for better control
                                },
                                '& input:-webkit-autofill': {
                                  boxShadow: '0 0 0 1000px #fff inset !important',
                                  WebkitTextFillColor: '#000 !important',
                                  transition: 'background-color 5000s ease-in-out 0s',
                                },
                              },
                            }}
                          />
                          <ErrorFocus />
                        </Grid>
                        {/* <Grid item xs={12} sm={12}>
                          <PhoneNumber value={values.phone} onChange={handleInputChangePhone}  fullWidth country="us" specialLabel="" />
                        </Grid> */}
                        <Grid item xs={12} sm={12}>
                          <Typography variant="subtitle1" style={{ fontSize: "12px", color: '#333', fontWeight: 500, marginLeft: '15px', paddingTop: "5px", borderRadius: '30px' }} color="textSecondary">
                            {t('Phone Number')}
                          </Typography>

                          {/* <PhoneInput
                            localization={es}
                            fullWidth
                            value={values.phone}
                            onChange={(value) => {
                              handleChange({ target: { name: 'phone', value } });
                            }}
                            onBlur={handleBlur}
                            inputProps={{ name: 'phone',  placeholder: "" }}

                            containerStyle={{
                              width: "100%",
                              position: "relative",
                            }}

                            inputStyle={{
                              width: "100%",
                              height: "43px",
                              borderRadius: "8px",
                              paddingLeft: "48px",
                              border:
                                errors.phone && touched.phone
                                  ? "1px solid #22C55E"
                                  : "1px solid #cacaca",
                            }}

                            dropdownStyle={{
                              zIndex: 2000,
                              position: "absolute",
                            }}
                          /> */}
                          {/* <PhoneInput
  localization={es}
  fullWidth
  value={values.phone}
  onChange={(value) => {
    handleChange({ target: { name: 'phone', value } });
  }}
  onBlur={handleBlur}
  inputProps={{ name: "phone", placeholder: "" }}
  inputClass="phone-input"

  containerStyle={{
    width: "100%",
    position: "relative",
  }}

  inputStyle={{
    width: "100%",
    height: "43px",
    borderRadius: "8px",
    paddingLeft: "48px",
    border: "1px solid #cacaca",
    outline: "none",
  }}

  dropdownStyle={{
    zIndex: 2000,
    position: "absolute",
  }}
/> */}

                          <PhoneInput country={'in'}
                            localization={es}
                            id='outlined-basic'
                            value={values.phone}
                            onChange={(value) => {
                              handleChange({ target: { name: "phone", value } });
                            }}
                            onBlur={handleBlur}
                            inputProps={{ name: "phone", placeholder: "" }}
                            inputClass="phone-input"

                            containerStyle={{
                              width: "100%",
                              marginTop: "5px",
                              borderRadius: "30px",
                              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              background: "#fff",
                            }}

                            inputStyle={{
                              width: "100%",
                              height: "43px",
                              borderRadius: "30px",
                              paddingLeft: "52px",
                              border: "transparent",
                              boxShadow: "none",
                              fontSize: "0.85rem",
                              background: "transparent",
                            }}

                            buttonStyle={{
                              borderRadius: "30px 0 0 30px",
                              border: "none",
                              boxShadow: "none",
                              background: "transparent",
                            }}

                            buttonClass="phone-flag-btn"

                            dropdownStyle={{
                              zIndex: 2000,
                            }}
                          />


                          {/* <PhoneNumber

                            value={values.phone}
                            onChange={(value) => {
                              handleChange({ target: { name: 'phone', value } });
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            country={'us'}
                            error={Boolean(touched.phone && errors.phone)}
                            helperText={touched.phone && errors.phone ? t(errors.phone) : ''}
                            inputProps={{
                              name: 'phone',
                            }}
                            containerStyle={{
                              width: '100%',
                              marginTop: '5px',
                            }}
                            inputStyle={{
                              width: '100%',
                              borderRadius: '30px',
                              borderColor: 'transparent',
                              boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                              padding: '10px 14px',
                            }}
                            sx={{
                              '& input::placeholder': {
                                fontSize: '0.85rem',
                              },
                            }}
                            buttonStyle={{
                              borderRadius: '30px 0 0 30px',
                            }}

                          /> */}

                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <Typography variant="subtitle1" style={{ fontSize: "12px", color: '#333', fontWeight: 500, marginLeft: '15px', paddingTop: "5px" }} color="textSecondary">
                            Create Password <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <TextField
                            fullWidth
                            id="outlined-basic"
                            name="password"
                            color="success"
                            // placeholder={t('Create Password')}
                            placeholder={'Create a password'}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              const { value } = e.target;
                              handleChange(e);
                              const error = validatePassword(value);

                              if (error) {
                                setPasswordError(error);
                              } else {
                                setPasswordError('');
                              }
                            }}
                            type={visible ? 'text' : 'password'}
                            value={values.password}
                            variant="outlined"
                            error={Boolean(touched.password && errors.password)}
                            helperText={touched.password && errors.password ? t(errors.password) : ''}
                            sx={{
                              marginTop: "5px",
                              borderRadius: '30px',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '30px',
                                '& fieldset': {
                                  borderColor: 'transparent',
                                  backgroundColor: 'none',
                                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                                },
                                '& input::placeholder': {
                                  fontSize: '0.85rem',
                                },
                                '& input': {
                                  padding: '8px 14px', // Adjust this to reduce height
                                  height: 'auto', // Optional, for better control
                                },
                                '& input:-webkit-autofill': {
                                  boxShadow: '0 0 0 1000px #fff inset !important',

                                  WebkitTextFillColor: '#000 !important',
                                  transition: 'background-color 5000s ease-in-out 0s',
                                },
                              },
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {visible ? (
                                    <VisibilityIcon
                                      className={classes.visibleIcon}
                                      onClick={handleClickShowPassword}
                                    />
                                  ) : (
                                    <VisibilityOffIcon
                                      className={classes.visibleIcon}
                                      onClick={handleClickShowPassword}
                                    />
                                  )}
                                </InputAdornment>
                              ),
                            }}
                          />
                          <ErrorFocus />
                        </Grid>

                        <Grid xs={12}>
                          <div
                            style={{
                              display: 'grid',
                              placeItems: 'center',
                              // marginTop: '20px',
                              marginLeft: '15px',
                              paddingTop: "10px",
                            }}
                          >
                            <FormControlLabel style={{ marginRight: '0px' }}
                              control={
                                <Checkbox
                                  id="agreeToTermsCheckbox"
                                  name="agreeToTerms"
                                  checked={values.agreeToTerms}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  color="primary"
                                  sx={{
                                    position: "relative",
                                    top: '3px',
                                    paddingLeft: '0px',
                                    color: 'rgb(90, 90, 90)',

                                    '&.Mui-checked': {
                                      color: 'rgb(81, 156, 254)',
                                    },
                                    '& input': {
                                      padding: '8px 14px',
                                      height: 'auto',
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography id="fontSmall" style={{
                                  fontSize: '13px', lineHeight: '1.3',
                                  position: 'relative', paddingTop: '8px'
                                }}>
                                  {t("I agree to the")}{' '}
                                  <a
                                    href="https://www.keyskillset.com/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: '#519cfe',
                                      textDecoration: 'none',
                                    }}
                                  >
                                    {t('Terms & Conditions')}
                                  </a> and
                                  <a
                                    href="https://www.keyskillset.com/terms"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: '#519cfe',
                                      textDecoration: 'none',
                                    }}
                                  >
                                    {t(' Privacy Policy')}
                                  </a>
                                </Typography>
                              }
                            />

                          </div>
                        </Grid>
                        {touched.agreeToTerms && errors.agreeToTerms && (
                          <Typography style={{ marginLeft: 12, lineHeight: '1.2', marginTop: '5px' }} color="error" variant="body2">
                            {t(errors.agreeToTerms)}
                          </Typography>
                        )}
                        <Grid item xs={12}>
                          <LoadingButton
                            fullWidth
                            size="medium"
                            type="submit"
                            variant="contained"
                            loading={loading}
                            className={classes.createButton}
                            sx={{
                              borderRadius: '30px !important',
                              background: "#00b673",
                              '&:hover': {
                                backgroundColor: "#00b673 !important",
                              }
                            }}
                          >
                            {t('Create Account')}
                          </LoadingButton>
                          {/* <Button onClick={() => CreateButton(values)}>Create an Account</Button> */}
                        </Grid>
                        <Grid item xs={12} sx={{ marginTop: '4px' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              textAlign: 'center',
                              color: '#999',
                              mb: 1.5,
                              '&::before, &::after': {
                                content: '""',
                                flex: 1,
                                borderBottom: '1px solid #ccc',
                              },
                              '&::before': { mr: 2 },
                              '&::after': { ml: 2 },
                            }}
                          >
                            <Typography variant="caption">{t('or continue with')}</Typography>
                          </Box>
                          <GoogleAuthButton onSuccess={handleGoogleAuthSuccess} onError={handleGoogleAuthError} />
                        </Grid>
                        <Grid align="center" item xs="12">

                          <Typography variant="body2" sx={{ display: 'flex', justifyContent: "center", marginTop: "5px", fontSize: "13px" }}>
                            {t('alreadyHaveAccount')} &nbsp;
                            {searchParams.get('isSubscribe') ? (
                              <Typography
                                component={RouterLink}
                                className={classes.create}
                                // to={'/login'}
                                to={{
                                  pathname: '/login',
                                  search: '?isSubscribe=true',
                                }}
                                sx={{ color: "#437BFC", fontSize: "13px", textDecoration: "none" }}
                              >
                                {t('login')}
                              </Typography>
                            ) : (
                              <Typography
                                component={RouterLink}
                                className={classes.create}
                                to={'/login'}
                                sx={{ color: "#437BFC", fontSize: "13px", textDecoration: "none" }}
                              >
                                {t('login')}
                              </Typography>
                            )}
                          </Typography>

                          <Button className={classes.ssoButton}
                            component={RouterLink}
                            to={'/login'} >
                            <ApartmentIcon className={classes.ApartmentIcon} sx={{ color: '#222' }} />  SSO
                          </Button>
                        </Grid>
                        {/* <Grid item xs={12}>
                    <Typography className={classes.email}>
                        For login related issue, &nbsp;
                        <RouterLink
                          to={{
                            // pathname: '/sign-up',
                            // search: '?isSubscribe=true',
                          }}
                          // state={location.state}
                          className={classes.signup}
                        >
                          Get Help
                        </RouterLink>
                      </Typography>
                    </Grid> */}
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </Grid>

              <Grid item xs={12} md={7.5} id="hideSlider" ref={carouselRef}>
                <Carousel autoPlay
                  interval={4500}
                  showArrows={false}
                  showStatus={false}
                  axis='horizontal'
                  infiniteLoop
                  showThumbs={false}
                  showIndicators={false}
                  className={classes.carouselContainer}
                  style={{ height: carouselHeight }}
                >
                  {images.map((image, idx) => (
                    <div key={idx} style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                      <img
                        className={classes.slideImg}
                        alt={` ${idx + 1}`}
                        src={image}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '15px'
                        }}
                      />
                    </div>
                  ))}
                </Carousel>
              </Grid>
            </Grid>
          </Container>
          {/* <SnackBar open={false} snackbarTitle={''} close={() => {}} />  */}
          <SnackBar open={snackbar} snackbarTitle={snackbarTitle} close={() => setSnackbar(false)} />
        </Box>

        :
        <Register details={details} userDetails={userDetails} />
      }


    </>

  );
};

const useStyles = makeStyles((theme) => ({
  image: {
    height: 'auto',
    width: '100%',
    marginTop: '155px',
    '@media (max-width: 600px)': {
      marginTop: '20px'
    }
  },
  login: {
    marginBottom: theme.spacing(2),
    marginTop: "0px",
    '@media (max-width: 500px)': {
      marginBottom: '0px',
      marginTop: '20px'
    }
  },
  container: {
    maxWidth: '1440px',
    margin: 'auto',
  },
  lineHeight1: {
    marginTop: '70px',
    marginBottom: '20px',
    fontSize: '22px',
    color: '#101828',
  },
  about: {
    color: '#000000',
    fontSize: '0.95rem',
    fontWeight: '450',
    textAlign: 'center',
  },


  contentalignment: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '2.5rem 0rem 4rem 0rem',
    flexWrap: 'wrap',
  },
  create: {
    color: '#437BFC',
    fontSize: '13px',
    cursor: 'pointer',
    fontWeight: '450',
    margin: '0px 10px 0px 0px',
    textDecoration: 'none',
  },

  cardscontainer: {
    height: 'auto',
    backgroundColor: '#E7F7EF',
    padding: '4rem 6.5rem',
    '@media (max-width: 640px)': {
      padding: '2rem 1.5rem',
    },
  },
  headingHands: {
    color: '#FFFFFF',
    fontSize: '1.2rem',
    marginLeft: '14px',
  },
  hands: {
    maxWidth: '84%',
    color: '#FFFFFF',
    fontSize: '1rem',
    fontWeight: 200,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },
  form: {
    paddingRight: '0px',
    paddingLeft: '120px',
    paddingTop: '64px',
    paddingBottom: '64px',


    '@media (max-width: 1199px)': {
      padding: '2rem 4rem 4rem 5rem',
    },
    [theme.breakpoints.down('md')]: {
      padding: '2rem 5rem 4rem 5rem',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0rem 2rem',
    },
    '@media (max-width: 400px)': {
      padding: '2rem 1rem 3rem 1rem',
    },
  },
  content: {
    fontSize: '1.1rem',
    color: '#667085',
    marginBottom: '2rem',
  },
  started: {
    backgroundColor: '#EC7930',
    borderRadius: '100px',
    color: '#fff',
    padding: '8px',
    fontWeight: '400',
    textTransform: 'capitalize ! important',
    marginTop: '1rem',
    '&:hover': {
      backgroundColor: '#EC7930',
      boxShadow: '0 0 1px 6px rgba(236, 121, 48, 40%),0 0 1px 0px rgba(236,121,48, 20%)',
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  email: {
    padding: '2px',
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400"
  },
  visibleIcon: {
    color: 'grey',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  signup: {
    color: "#D52F37"
  },

  mainContainer: {
    background: "#F0F0F0",
    height: '100vh',
    display: 'flex',
    '@media (max-width: 767px)': {
      padding: "20px 0",
    },
  },
  boxContainer: {
    backgroundImage: `url(${BackgroundImg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    // height: '100vh',
    width: "500px",
    minHeight: "532px",
    marginTop: "12px",
    borderRadius: "20px",
    // animationName: "changeBackground",
    // animationDuration: "12s",
    // animationIterationCount: "infinite",
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    '@media (max-width: 767px)': {
      height: '240px',
      marginTop: '70px'
    },

  },
  formcontainer: {
    background: "#FFFFFF",
    padding: '26px',
    paddingTop: '18px',
    borderRadius: "20px",
    paddingBottom: '18px',
    marginTop: "0px",
    minHeight: "500px",
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
    },
  },
  SignupPanel: {
    display: 'flex',
    alignItems: 'center',
    minHeight: "100%",
  },

  createButton: {
    borderRadius: '30px',
    marginTop: '5px',
    background: "#00b673",
    fontSize: "12px",
  },
  text_one: {
    fontSize: "12px",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    // marginTop: "10px",
  },
  carouselContainer: {
    backgroundColor: 'transparent',
    maxWidth: '100%',
    margin: 'auto',
    transition: 'height 0.3s ease',
    '& .carousel-slider, & .slider-wrapper, & .slider': {
      height: '100% !important',
    },
  },
  ssoButton: {
    width: '250px',
    borderRadius: '30px',
    border: '1px solid #222',
    backgroundColor: '#fff',
    cursor: 'pointer',
    visibility: 'hidden',
    color: '#222',
    '&:hover': {
      backgroundColor: '#222',
      color: '#fff',
      border: '1px solid #222',
      '& .MuiSvgIcon-root': {
        color: '#fff',
      },
    },
  },
  ApartmentIcon: {
    marginRight: '12px',
  },
  whiteBorder: {
    background: "whitesmoke",
    marginTop: '10px',
    height: "1px",
    padding: '1px',
    borderRadius: '5px',
    marginLeft: '15px'
  },
  slideImg: {
    height: '100%',
    objectFit: 'cover',
    '@media (max-width: 540px)': {
      maxHeight: '250px',
    }
  },
  '@global': {
    '.react-tel-input .country-list .country': {
      display: 'flex!important',
      alignContent: 'center',
      gap: '10px',
      padding: '8px 12px',
      // marginLeft:'30px!important'

    },
    '.react-tel-input .country-list .country-name': {
      marginLeft: '30px!important'
    },
    '.react-tel-input .phone-input:focus': {
      border: '1px solid #72dd51 !important',
      boxShadow: 'none'
    },

    '.react-tel-input .phone-input:focus  .flag-dropdown .selected-flag': {
      borderRight: '1px solid #72dd51 !important'
    },

    '.react-tel-input .phone-input': {
      outline: 'none'
    },

    /* When hovering the flag button while input is focused */
    // '.react-tel-input .phone-input:focus + .flag-dropdown .selected-flag, .react-tel-input .flag-dropdown:hover .selected-flag': {
    //   borderTop: '2px solid #72dd51 !important',
    //   borderBottom: '2px solid #72dd51 !important',
    //   borderLeft: '2px solid #72dd51 !important',
    //   borderRadius: '30px 0 0 30px !important',
    // },


    '.react-tel-input .flag-dropdown.open .selected-flag': {
      borderRadius: '30px 0 0 30px !important',
    },

    '.react-tel-input .flag-dropdown:hover .selected-flag': {
      borderRadius: '30px 0 0 30px !important',
    },


    // '.react-tel-input':{
    // marginLeft:'10px!important'
    // },
    // '.country-list':{
    // marginLeft:'10px!important'
    // },
    // '.country':{
    // marginLeft:'10px!important'
    // },
    // '.flag':{
    // marginLeft:'10px!important'
    // },

    // /* Prevent text overlap */
    // .react-tel-input .country-list .country-name {
    //   white-space: nowrap;
    // }
  }

}));